if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
        this.mobileNavigationInitialized = false;
        this.navigationUpdateTimer = null;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);

        /*
         * IMPORTANT:
         * Do not initialize any of the carousel/navigation code
         * unless this is actually a mobile device.
         */
        if (this.isMobile()) {
          this.initializeMobileNavigation();
        }

        this.showActiveMedia();
      }

      isMobile() {
        return this.mobileMediaQuery.matches;
      }

      initializeMobileNavigation() {
        if (this.mobileNavigationInitialized) return;

        this.mediaContainer = this.querySelector(
          '.product-media-modal__content'
        );

        this.previousButton = this.querySelector(
          '[data-product-modal-prev]'
        );

        this.nextButton = this.querySelector(
          '[data-product-modal-next]'
        );

        if (!this.mediaContainer) return;

        this.previousButton?.addEventListener('click', () => {
          this.changeSlide(-1);
        });

        this.nextButton?.addEventListener('click', () => {
          this.changeSlide(1);
        });

        this.mediaContainer.addEventListener(
          'scroll',
          () => {
            if (!this.isMobile()) return;

            window.clearTimeout(this.navigationUpdateTimer);

            this.navigationUpdateTimer = window.setTimeout(() => {
              this.updateNavigation();
            }, 50);
          },
          { passive: true }
        );

        this.mobileNavigationInitialized = true;
      }

      getSlides() {
        if (!this.mediaContainer) return [];

        return Array.from(
          this.mediaContainer.querySelectorAll(
            ':scope > [data-media-id]'
          )
        );
      }

      getCurrentSlideIndex() {
        const slides = this.getSlides();

        if (
          !this.mediaContainer ||
          !this.mediaContainer.clientWidth ||
          !slides.length
        ) {
          return 0;
        }

        const index = Math.round(
          this.mediaContainer.scrollLeft /
            this.mediaContainer.clientWidth
        );

        return Math.max(
          0,
          Math.min(index, slides.length - 1)
        );
      }

      changeSlide(direction) {
        if (!this.isMobile() || !this.mediaContainer) return;

        const slides = this.getSlides();

        if (slides.length < 2) return;

        const currentIndex = this.getCurrentSlideIndex();

        const nextIndex = Math.max(
          0,
          Math.min(
            currentIndex + direction,
            slides.length - 1
          )
        );

        this.mediaContainer.scrollTo({
          left:
            nextIndex *
            this.mediaContainer.clientWidth,
          top: 0,
          behavior: 'smooth',
        });
      }

      updateNavigation() {
        if (!this.isMobile()) return;

        const slides = this.getSlides();

        if (!slides.length) return;

        const currentIndex =
          this.getCurrentSlideIndex();

        if (this.previousButton) {
          this.previousButton.disabled =
            currentIndex === 0;
        }

        if (this.nextButton) {
          this.nextButton.disabled =
            currentIndex === slides.length - 1;
        }
      }

      showActiveMedia() {
        const mediaId =
          this.openedBy?.getAttribute('data-media-id');

        if (!mediaId) return;

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${mediaId}"]`
        );

        if (!activeMedia) return;

        const activeMediaTemplate =
          activeMedia.querySelector('template');

        const activeMediaContent =
          activeMediaTemplate
            ? activeMediaTemplate.content
            : null;

        activeMedia.classList.add('active');

        const container =
          this.querySelector('[role="document"]');

        if (!container) return;

        if (this.isMobile()) {
          /*
           * MOBILE ONLY
           * Initialize and position horizontal gallery.
           */
          this.initializeMobileNavigation();

          const slides = this.getSlides();
          const activeIndex =
            slides.indexOf(activeMedia);

          requestAnimationFrame(() => {
            container.scrollTo({
              left:
                Math.max(activeIndex, 0) *
                container.clientWidth,
              top: 0,
              behavior: 'auto',
            });

            this.updateNavigation();
          });
        } else {
          /*
           * DESKTOP
           *
           * Keep Dawn's original behavior as lean as possible.
           */
          activeMedia.scrollIntoView();

          container.scrollLeft =
            (activeMedia.width -
              container.clientWidth) /
            2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}